import { render, staticRenderFns } from "./MacroButton.vue?vue&type=template&id=74663553&"
import script from "./MacroButton.vue?vue&type=script&lang=js&"
export * from "./MacroButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports